





















































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

import { PublishStatus } from '@/store/types';
import { LocationsActions } from '@/store/modules/locations/types';
import SubmitButton from '@/components/controls/submit-button.vue';
import PracticeSelectionControl from '@/components/controls/practice-selection.vue';
import Dropdown, { DropdownItems } from '@/components/controls/dropdown.vue';
import { ReportsActions } from '@/store/modules/reports/types';
import CountrySelection from '@/components/controls/country-selection.vue';

export default Vue.extend({
  name: 'LocationsFilterForm',
  components: {
    SubmitButton,
    PracticeSelectionControl,
    Dropdown,
    CountrySelection,
  },
  props: {
    selectedItems: {
      type: Array,
      default: () => [] as number[],
    },
  },
  data() {
    return {
      availableStatuses: {
        [PublishStatus.Pending]: this.$t('Pending review'),
        [PublishStatus.Draft]: this.$t('Draft'),
        [PublishStatus.Published]: this.$t('Published'),
        [PublishStatus.Deleted]: this.$t('Deleted'),
        [PublishStatus.Declined]: this.$t('Requires Changes'),
      },
      status: '',
      search: '',
      practice: undefined,
      country: 0,
    };
  },
  computed: {
    ...mapGetters('locations', {
      isLoading: 'listIsLoading',
      isLoaded: 'listIsLoaded',
      isError: 'listIsError',
      isEmpty: 'listIsEmpty',
    }),
    ...mapGetters('user/profile', ['isSuperAdmin', 'isAdmin']),
    dropdownItems() {
      const items: DropdownItems = {};

      if (this.isSuperAdmin) {
        items.report = {
          label: this.$t('Generate Report'),
          icon: 'document',
        };
      }

      items.reset = {
        label: this.$t('Reset Filters'),
        icon: 'close',
      };

      if ((this.isSuperAdmin || this.isAdmin) && this.selectedItems && this.selectedItems.length) {
        items.publish = {
          hasTopBorder: true,
          label: this.$t('Make Published'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };

        items.remove = {
          label: this.$t('Delete'),
          count: this.selectedItems.length,
          disabled: !this.selectedItems.length,
        };
      }

      return items;
    },
  },
  methods: {
    ...mapActions('reports', {
      requestReport: ReportsActions.REQUEST,
    }),
    ...mapActions('locations', {
      deleteLocations: LocationsActions.BULK_DELETE,
      publishLocations: LocationsActions.BULK_RESTORE,
    }),
    initFilters(): void {
      this.search = this.$router.currentRoute.query.search || '';
      this.status = this.$router.currentRoute.query.status || '';
      this.country = Number(this.$router.currentRoute.query.country_id) || 0;

      let newPracticeValue;

      if (this.$router.currentRoute.query.practice_id) {
        newPracticeValue = Number(this.$router.currentRoute.query.practice_id);

        if (!newPracticeValue || Number.isNaN(newPracticeValue)) {
          newPracticeValue = undefined;
        }
      }

      if (this.practice !== newPracticeValue) {
        this.practice = newPracticeValue;
      }
    },
    applyFilters(): void {
      const { sort, direction, ...queryParams } = this.$route.query;

      this.$router.push({
        params: {
          page: 1,
        },
        query: {
          ...queryParams,
          status: this.status,
          search: this.search,
          practice_id: this.practice,
          country_id: this.country ? String(this.country) : undefined,
        },
      });
    },
    handleDropdownClick(action: string): void {
      if ('reset' === action) {
        this.$router.push({
          params: {
            page: 1,
          },
          query: {},
        });
      }

      if ('report' === action) {
        this.requestReport();
      }

      if ('publish' === action) {
        this.publishLocations({ ids: this.selectedItems });
      }

      if ('remove' === action) {
        this.deleteLocations({ ids: this.selectedItems });
      }
    },
  },
  created(): void {
    this.initFilters();
  },
  watch: {
    $route(): void {
      this.initFilters();
    },
  },
});
